module.exports = __webpack_public_path__ + "assets/img/logo.bdd763fe.png";